// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__I6DXM","reportBodyText":"style__reportBodyText__8FK8p"};